import axios from 'axios';

const API_URL = process.env.REACT_APP_QUOTE_API;


export const storeCustomerAndQuotes = async (quote, solution, customerDetails, user_id, attachment, totalCost) => {

  try {
    // Send a single request to store both customer and quote data
    const response = await axios.post(`${API_URL}/home/submit`, {
      quote,
      solution,
      customerDetails,
      user_id,
      attachment,
      totalCost
    });
    // Check if the response structure is as expected
    if (!response || !response.data) {
      throw new Error('Failed to store data: Unexpected response structure');
    }

    return {
      customerData: response.data.customer,
      quoteData: response.data.quote,
      message: response.data.message
    };
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data);
    } else {
      throw new Error('Failed to connect to the server');
    }
  }
};

export const getPresignedUrl = async (bucket, fileName) => {
  try {
      const {data} = await axios.get(`${API_URL}/home/presigned-url`, {
         params: { bucket,
          fileName }
      });
      return data;
  }catch(err) {
      throw err;
  }
};

export const generatePresignedUrl = async (fileName, fileType) => {
  try{
      const {data} = await axios.post(`${API_URL}/home/presigned-url`, {fileName, fileType}, {
          headers: {
              'Content-Type': 'application/json'
          }
      });
      return data;
  } catch (err) {
      throw err;
  }
};

export const getInitialData = async (selectedSolutionId) => {
  try {
    const response = await axios.get(`${API_URL}/home/solutions?solutionId=${selectedSolutionId}`);
    if (response.status === 200) return response.data;
  } catch (err) {
    throw err;
  }
};

export const getQuestions = async (solutionId) => {
  try {
    const response = await axios.get(`${API_URL}/home/questions?solutionId=${solutionId}`);
    if (response.status === 200) return response.data;
  } catch (err) {
    throw err;
  }
};

export const getPaymentTerms = async (solutionHeaderId, sequence) => {
  try {
    const response = await axios.get(`${API_URL}/home/payment-terms`, {
      params: {
        solutionHeaderId,
        sequence
      }
    });    

    if (response.status === 200) return response.data;
  } catch (err) {
    throw err;
  }
};

export const getBufferData = async (solutionHeaderId) => {
  try {
    const response = await axios.get(`${API_URL}/home/buffer-data?solutionHeaderId=${solutionHeaderId}`);
    const bufferData = response.data.payLoad 
    if (response.status === 200) return bufferData;
  } catch (err) {
    throw err;
  }
};

export const getEmails = async () => {
  try {
    const response = await axios.get(`${API_URL}/home/get-emails`);
    const emails = response.data.payLoad 
    if (response.status === 200) return emails;
  } catch (err) {
    throw err;
  }
};

export const sendQuoteMail = async(emails, quoteData) => {
  try{
    const response = await axios.post(`${API_URL}/home/sendQuoteThroughMail`, {emails, quoteData}, {
      headers: {
          'Content-Type': 'application/json'
      }
  });
  return response;
  }catch(err){
    throw err;
  }
}

export const getPriorityOptions = async() => {
  try{
    const response = await axios.get(`${API_URL}/home/priority-options`)
    return response;
  }catch(err){
    throw err;
  }
}

export const getSpecialPriorityOptions = async() => {
  try{
    const response = await axios.get(`${API_URL}/home/special-priority-options`)
    return response.data.payLoad;
  }catch(err){
    console.error('Error details:', err.response ? err.response.data : err.message);
  throw err;
  }
}

export const getSpecialOptions = async(solutionId) => {
  try{
    const response = await axios.get(`${API_URL}/home/priority-data?solutionHeaderId=${solutionId}`)
    return response.data.payLoad;
  }catch(err){
    throw err;
  }
}

export const getSpecialPaymentTerm = async(solutionId) => {
  try{
    const response = await axios.get(`${API_URL}/home/priority-terms?solutionHeaderId=${solutionId}`)
    return response.data.payLoad;
  }catch(err){
    throw err;
  }
}

export const sendMailToCustomer = async(email, quoteData, attachment, bucket) => {
  try{
    const response = await axios.post(`${API_URL}/home/sendMailToCustomer-quoteData`, {email, quoteData, attachment, bucket}, {
      headers: {
          'Content-Type': 'application/json'
      }
  });
    return response;
  }catch(err){
    console.log(err);
    throw err;
  }
}